module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('b')]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('b', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("My thanks to the following people who read this novel in manuscript and gave me advice on changes:")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Ruth Berman, John Douglas, David G. Hartwell, Eric M. Heideman, Albert W. Kuhfeld, Mike Levy, Sandra Lindow, and Shoshona Pederson.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Al Kuhfeld designed the wonderful starship and read the novel with an eye for errors in science. The manuscript went through three revisions after he saw it, and he is in no way responsible for any new errors that may have been introduced. Susan Pederson helped me design the culture of the Iron People. Ruth Berman came up with my favorite name for the starship. P. C. Hodgell drew the map.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("My special thanks to Bill Gober, who heard me talk about the novel years ago at Minicon. Every year since then he has come up to me at Minicon and loomed over me and said, “Have you finished the novel about the furry people yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Here it is, Bill. I hope it’s worth the wait.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-407b22ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/section3.vue
// module id = 87
// module chunks = 0